import Column from "@/Components/Grid/Column";
import Container from "@/Components/Grid/Container";
import Row from "@/Components/Grid/Row";
import FrontText from "../FrontText";
import { Link } from "@inertiajs/react";
import { Icon } from "@iconify/react";
import NEWEST_POSTS_FRAGMENT from "@/Query/Fragments/NEWEST_POSTS_FRAGMENT";
import LargeSkeleton from "@/Components/Preloaders/LargeSkeleton";
import Skeleton from "@/Components/Preloaders/Skeleton";

import GraphImage from "../GraphImage/GraphImage";
import { Trans, useTranslation } from 'react-i18next';
import FrontSquareBeforeText from "../Partials/FrontSquareBeforeText";
import sanitizeHTML from "@/Helpers/sanitizeHTML";

// import * as ApolloPkg from '@apollo/client';
// import { gql } from '@apollo/client/core/core.cjs';
// import { useQuery } from "@apollo/client/react/hooks/hooks.cjs";
// import { useQuery, gql } from "@apollo/client/apollo-client.min.cjs";
// import { useQuery, gql } from "@apollo/client";
import gql from 'graphql-tag';
import { useQuery } from "@apollo/client/react/hooks/hooks.cjs";

const FrontLatestPosts = ({ postType, tax, taxEn, linkToAll }) => {
    const { t, i18n } = useTranslation();
    // const { gql, useQuery } = ApolloPkg;
    const currentLanguage = i18n.resolvedLanguage.toUpperCase();

    const LATEST_POSTS_FROM_TAX = gql`
        query GetPosts($categoryName: String!, $lang: LanguageCodeFilterEnum!) {
            posts(first: 3, where: { categoryName: $categoryName, status: PUBLISH, language: $lang } ) {
                edges {
                    node {
                        ${NEWEST_POSTS_FRAGMENT}
                    }
                }
            }
        }
    `;
    
    const { loading, error, data } = useQuery(LATEST_POSTS_FROM_TAX, {
        variables: { categoryName: currentLanguage === 'PL' ? tax : taxEn, lang: currentLanguage },
        ssr: true,
    });

    return (
        <Container>
            <Row>
                <Column className='mb-8'>
                    <div className="flex justify-between items-center gap-2">
                        <FrontSquareBeforeText>
                            {postType}
                        </FrontSquareBeforeText>

                        <Link preserveScroll={false} href={linkToAll} title={t('news_page.show_more') + ' ' + postType.toLowerCase()} className="inline-flex py-c10  gap-1.5 px-4 text-dark-blue-standard hover:text-white border-2 border-dark-blue-standard hover:bg-dark-blue-standard transition-all ease-in-out duration-300 items-center rounded-20">
                            <FrontText textSize='16/20' className=" font-medium">
                                <span>{t('news_page.show_more')}</span>
                            </FrontText>
                            <Icon icon={'material-symbols:arrow-outward-rounded'} height={20} width={20} className="shrink-0" />
                        </Link>
                    </div>
                </Column>
                <Column>
                    <Row className={'gap-y-10'}>
                        {error &&
                            <Column>
                                <Skeleton />
                            </Column>
                        }
                        {loading
                            ?
                            <>
                                <Column xl={5} lg={4} md={4}>
                                    <LargeSkeleton />
                                </Column>
                                <Column lg={4} md={4} className='xl:hidden'>
                                    <LargeSkeleton />
                                </Column>
                                <Column lg={4} md={4} className='xl:hidden'>
                                    <LargeSkeleton />
                                </Column>
                                <Column xl={7} lg={7} md={4} className='hidden gap-10 flex-col xl:flex'>
                                    <Skeleton />
                                    <Skeleton />
                                </Column>
                            </>
                            :
                            <>
                                <Column xl={5} lg={4} md={4}>
                                    {data && data.posts.edges.slice(0, 1).map((elem, index) => {
                                        const { id, slug, title, featuredImage, date, excerpt } = elem.node
                                        const { sizes } = featuredImage.node.mediaDetails
                                        const { mediaItemUrl } = featuredImage.node
                                        
                                        return (
                                            <Link
                                                preserveScroll={false}
                                                key={id + index}
                                                href={route(currentLanguage === 'PL' ? 'front.news.single' : 'front.news.single.en', {taxonomy: currentLanguage === 'PL' ? tax : taxEn, slug: slug})}
                                                title={title}
                                                className="block hover:[&_.article-inner]:bg-dark-blue-standard hover:[&>article]:drop-shadow-article-box [&:hover_.content]:text-white"
                                            >
                                                <article className="rounded-10 overflow-hidden h-full border border-ECECEC drop-shadow-none transition-all ease-in-out duration-300">
                                                    <div className="article-inner bg-white flex flex-col h-full transition-all ease-in-out duration-300">
                                                        <div>
                                                            <GraphImage lazy='lazy' sizes={sizes} original={mediaItemUrl} className="w-full" alt={title} />
                                                        </div>

                                                        <div className="py-5 px-5 flex flex-col gap-5">
                                                            <FrontText textSize='14/20' className="content font-bold font-domine text-standard-black transition-all ease-in-out duration-300 uppercase">
                                                                <p>
                                                                    {title}
                                                                </p>
                                                            </FrontText>

                                                            <FrontText textSize='14/20' className="content font-domine text-standard-black transition-all ease-in-out duration-300">
                                                                {sanitizeHTML(excerpt)}
                                                            </FrontText>

                                                            <div className="flex items-center justify-between text-30548A">
                                                                <FrontText textSize='14/16' className="font-bold font-domine">
                                                                    <span>
                                                                        {new Date(date).toLocaleDateString(currentLanguage, { day: 'numeric', month: 'long', year: 'numeric' })}
                                                                    </span>
                                                                </FrontText>

                                                                <Icon icon='material-symbols:menu-book-rounded' width={27} height={24} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </article>
                                            </Link>
                                        )
                                    })}
                                </Column>
                                <Column xl={7} lg={8} md={8} className='flex gap-y-10 gap-x-6 xl:flex-col md:flex-row flex-col'>
                                    {data && data.posts.edges.slice(1).map((elem, index) => {
                                        const { id, slug, title, featuredImage, date, excerpt } = elem.node
                                        const { sizes } = featuredImage.node.mediaDetails
                                        const { mediaItemUrl } = featuredImage.node

                                        return (
                                            <Link 
                                                preserveScroll={false}
                                                key={id + index}
                                                href={route(currentLanguage === 'PL' ? 'front.news.single' : 'front.news.single.en', {taxonomy: currentLanguage === 'PL' ? tax : taxEn, slug: slug})}
                                                title={title}
                                                className="md:w-1/2 w-full xl:w-full block hover:[&_.article-inner]:bg-dark-blue-standard hover:[&>article]:drop-shadow-article-box [&:hover_.content]:text-white"
                                            >
                                                <article className="rounded-10 overflow-hidden h-full border border-ECECEC drop-shadow-none transition-all ease-in-out duration-300">
                                                    <div className="article-inner bg-white flex items-center xl:flex-row flex-col h-full transition-all ease-in-out duration-300">
                                                        <div className="xl:w-1/2 w-full xl:pr-5 xl:h-full">
                                                            <GraphImage lazy='lazy' sizes={sizes} original={mediaItemUrl} className="w-full h-full object-cover object-left" alt={title} />
                                                        </div>

                                                        <div className="xl:w-1/2 w-full py-5 xl:pl-0 px-5 xl:pr-c30 flex flex-col h-full">
                                                            <FrontText textSize='14/20' className="mb-4 content font-bold font-domine text-standard-black transition-all ease-in-out duration-300 uppercase">
                                                                <p>{title}</p>
                                                            </FrontText>

                                                            <FrontText textSize='14/20' className="mb-1 content font-domine text-standard-black transition-all ease-in-out duration-300">
                                                                {sanitizeHTML(excerpt)}
                                                            </FrontText>

                                                            <div className="flex items-center justify-between text-30548A mt-auto">
                                                                <FrontText textSize='14/16' className="font-bold font-domine">
                                                                    <span>
                                                                        {new Date(date).toLocaleDateString(currentLanguage, { day: 'numeric', month: 'long', year: 'numeric' })}
                                                                    </span>
                                                                </FrontText>

                                                                <Icon icon='material-symbols:menu-book-rounded' width={27} height={24} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </article>
                                            </Link>
                                        )
                                    })}
                                </Column>
                            </>
                        }
                    </Row>
                </Column>
            </Row>
        </Container>
    )
}

export default FrontLatestPosts;